import { render, staticRenderFns } from "./SurveyItem.vue?vue&type=template&id=1b4a93ee&scoped=true"
import script from "./SurveyItem.vue?vue&type=script&lang=js"
export * from "./SurveyItem.vue?vue&type=script&lang=js"
import style0 from "./SurveyItem.vue?vue&type=style&index=0&id=1b4a93ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4a93ee",
  null
  
)

export default component.exports